export default __webpack_public_path__ + "8c1a41026a861bf04b8ae5c2b9f95d7d.woff2";